import { setProcurementItems } from '../State/procurementItems';

export default (itemId, field, value) => (dispatch, getState) => {
  const state = getState();
  const procurementItems = state.screens.OrderView.procurementItems;
  
  // Update the item in the array (handle both null and real IDs)
  const updatedItems = procurementItems.map(item => {
    if (item.id === itemId) {
      return { ...item, [field]: value };
    }
    return item;
  });
  
  dispatch(setProcurementItems(updatedItems));
}
